import { Checkbox, FormControlLabel, Stack, SxProps, Theme, Typography } from "@mui/material";
import { useGroupsData } from "../../store/selectors/groupSelectors";
import { useEffect } from "react";
import { useAppDispatch } from "../../hooks/StoreHooks";
import { fetchGroupsThunk } from "../../store/thunk/groupsThunk";
import { useTranslation } from "react-i18next";

interface Props {
    value: number[];
    onChange: (selectedGroupIds: number[]) => void;
    sx?: SxProps<Theme>;
    companyId?: number
}

export default function SelectGroupsList(props: Props) {
    const { t } = useTranslation();
    const groupList = useGroupsData();
    const dispatch = useAppDispatch();

    useEffect(() => {
        if (groupList.length === 0) {
            dispatch(fetchGroupsThunk({
                companyId: props.companyId
            }));
        }
    }, [dispatch, groupList.length]);

    const handleGroupChange = (groupId: number) => {
        if (props.value.includes(groupId)) {
            props.onChange(props.value.filter(id => id !== groupId));
        } else {
            props.onChange([...props.value, groupId]);
        }
    };

    return <Stack sx={{ width: "300px", ...props.sx }}>
        <Typography variant="subtitle2" sx={{ mb: 0, width: "100%" }}>
            {t("groupsPage.groups.title")}
        </Typography>
        {groupList.map((group) => (
            <FormControlLabel
                key={group.id}
                control={
                    <Checkbox
                        checked={props.value.includes(group.id)}
                        onChange={() => handleGroupChange(group.id)}
                    />
                }
                label={group.name}
            />
        ))}
    </Stack>;
}